<template>
<div v-if="themeList.includes(issue.id)" class="col in-the-news">
    <div id="tabbed-menu-inline">
        <ul class="tab-list tab-list-space">
            <li class="tab tab-lg">
                <a :href="essentialReading" class="tab-anchor">
                    <div class="tab-icon-bg"><img src="/asset/img/icons/book_stack_icon.png" alt="" class="tab-icon tab-icon-lg"></div>
                    <span class="tab-text">Essential Reading</span>
                </a>
            </li>
            <li class="tab tab-lg">
                <a :href="primarySources" class="tab-anchor">
                    <div class="tab-icon-bg"><img src="/asset/img/icons/pen-paper.png" alt="" class="tab-icon tab-icon-lg"></div>
                    <span class="tab-text">Primary Sources</span>
                </a>
            </li>
            <li class="tab tab-lg">
                <a :href="secondarySources" class="tab-anchor">
                    <div class="tab-icon-bg"><img src="/asset/img/icons/newspaper.png" alt="" class="tab-icon tab-icon-lg"></div>
                    <span class="tab-text">Secondary Sources</span>
                </a>
            </li>
            <li class="tab tab-lg">
                <a :href="lessonPlans" class="tab-anchor">
                    <div class="tab-icon-bg"><img src="/asset/img/icons/classroom.png" alt="" class="tab-icon tab-icon-lg"></div>
                    <span class="tab-text">Lesson Plans</span>
                </a>
            </li>
            <li class="tab tab-lg">
                <a :href="multimediaResources" class="tab-anchor">
                    <div class="tab-icon-bg"><img src="/asset/img/icons/video-camera.png" alt="" class="tab-icon tab-icon-lg"></div>
                    <span class="tab-text">Multimedia Resources</span>
                </a>
            </li>
        </ul>
    </div>
</div>
<div v-else class="col in-the-news">
    <h3 class="section-heading" v-html="section.name"></h3>

    <div id="tabbed-menu-inline">
        <ul class="tab-list" ref="tab-list" >
            <!-- active -->
            <li class="tab" >
                <a href="/public_affairs/american_civics/lesson_plans/theme_one_civic_participation/index.html" class="tab-anchor" >
                    <div class="tab-icon-bg">
                        <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/thumb.png">
                    </div>
                    <span class="tab-text" >Civic Participation</span>
                </a>
            </li>
            <li class="tab" >
                <a href="/public_affairs/american_civics/lesson_plans/theme_two_our_changing_landscape/index.html" class="tab-anchor" >
                    <div class="tab-icon-bg">
                        <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/landscape.png">
                    </div>
                    <span class="tab-text" >Our Changing Landscape</span>
                </a>
            </li>
            <li class="tab" >
                <a href="/public_affairs/american_civics/lesson_plans/theme_three_we_the_people/index.html" class="tab-anchor" >
                    <div class="tab-icon-bg">
                        <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/people.png">
                    </div>
                    <span class="tab-text" >We the People</span>
                </a>
            </li>
            <li class="tab" >
                <a href="/public_affairs/american_civics/lesson_plans/theme_four_a_new_government_and_constitution/index.html" class="tab-anchor" >
                    <div class="tab-icon-bg">
                        <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/constitution.png">
                    </div>
                    <span class="tab-text" >A New Government &amp; Constitution</span>
                </a>
            </li>
            <li class="tab" >
                <a href="/public_affairs/american_civics/lesson_plans/theme_five_a_series_of_refoundings/index.html" class="tab-anchor" >
                    <div class="tab-icon-bg">
                        <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/communities.png">
                    </div>
                    <span class="tab-text" >A Series of Refoundings?</span>
                </a>
            </li>
            <li class="tab" >
                <a href="/public_affairs/american_civics/lesson_plans/theme_six_a_people_in_the_world/index.html" class="tab-anchor" >
                    <div class="tab-icon-bg">
                        <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/people_world.png">
                    </div>
                    <span class="tab-text" >A People in the World</span>
                </a>
            </li>
            <li class="tab" >
                <a href="/public_affairs/american_civics/lesson_plans/theme_seven_a_people_with_contemporary_debates/index.html" class="tab-anchor" >
                    <div class="tab-icon-bg">
                        <img class="tab-icon" src="https://realclearpolitics.com/asset/img/icons/debate.png">
                    </div>
                    <span class="tab-text" >A People with Contemporary Debates</span>
                </a>
            </li>
        </ul>
    </div>
</div> <!--End of col 1-->
</template>

<script>

/** 
 * @see https://www.educatingforamericandemocracy.org/the-roadmap/7themes/#we-the-people
 */

import SectionsMixin from './SectionsMixin.js';

export default {
    name: 'seven-ead-themes',
    mixins: [
        SectionsMixin,
    ],
    data() {
        return {
            // EAD portal themes
            themeList: [56,57,58,59,60,61,62],
            essentialReading: '/public_affairs/american_civics/lesson_plans/'+this.issue.slug+'/essential_reading.html',
            primarySources: '/public_affairs/american_civics/lesson_plans/'+this.issue.slug+'/primary_sources.html',
            secondarySources: '/public_affairs/american_civics/lesson_plans/'+this.issue.slug+'/secondary_sources.html',
            lessonPlans: '/public_affairs/american_civics/lesson_plans/'+this.issue.slug+'/lesson_planscurriculagames.html',
            multimediaResources: '/public_affairs/american_civics/lesson_plans/'+this.issue.slug+'/multimedia.html',
        }
    },
    mounted(){

        this.$nextTick(() => {
            setTimeout(() => {
                var num_tabs = this.$refs['tab-list'].children.length;
                this.tabs = this.$refs['tab-list'].children;
                this.tabs.forEach(tab => {
                    tab.$el.dataset['num-tabs'] = num_tabs;
                });
            }, 50);
        });
    },
}
</script>

<style lang="scss">
#tabbed-menu-inline{
    padding: 0px;
    margin: 0px;
    margin-top: 20px;

    .tab-list{
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding-inline-start: 0px;
        padding-inline-end: 0px;
        display: flex;
        justify-content: space-evenly;
        align-content: center;
        align-items: center;
        flex-direction: column;
        margin-bottom: 20px;
        padding: 0 50px;

        @media screen and (min-width: 768px){

            &{
                flex-direction: row;
                align-items: initial;
            }
        }

        .tab{
            list-style: none;
            padding: 0px;
            margin: 0px;
            width: 100%;
            max-width: 125px;
            background-color: #013220;
            // border: 1px #fff solid;
            border: 1px #013220 solid;
            // border-left: none;
            border-radius: 1px;

            @media screen and (min-width: 768px){

                &{
                    width: calc( (100vw - 50px) / attr(data-num-tabs) );
                    width: calc( (100vw - 50px) / 7 );
                }

                &:first-child{
                    // border-left: 1px #005a39 solid;
                    // border-left: 1px #fff solid;
                    border-left: 1px #013220 solid;
                }
            }

            .tab-anchor{
                display: inline-block;
                color: #fff;
                padding: 10px 20px 20px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .tab-icon-bg {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 10px 20px 0px 20px;
                    margin-bottom: 15px;

                    .tab-icon{
                        width: 30px;
                        height: 30px;
                        padding: 10px 0px 20px;

                        &-lg {
                            width: 40px;
                            height: 40px;
                        }
                    }
                }

                .tab-text{
                    text-align: center;
                    font-size: .9em;
                }
            }

            &.active,
            &:hover{
                background-color: #fff;
                // border: 1px #005a39 solid;
                // border: 1px #013220 solid;

                &:first-child{
                    // border-left: 1px #005a39 solid;
                    // border-left: 1px #013220 solid;
                }

                .tab-anchor{
                    color: #333;

                    .tab-icon-bg {
                        background-color: #013220;
                        border-radius: 100px;
                    }
                }
            }

            &-lg {
                height: 190px;
            }
        }

        &-space {
            padding: 0 200px;
        }
    }
}
</style>